import attribute_groups from "./attribute_groups";
import { product_brand } from "./brands";
import { product_category } from "./categories";
import { media_with_details } from "./media";
import { mix_variants, mix_variants_card, variants } from "./variant";

export const widget_product = `{
        id
        title
        brand {
        title
        custom_fields
        seo{
        full_url
        }
        }
        has_rating
        average_rate
        is_special
        summary
        is_favorite
        title_en
        price {
          price
          offer_price
          has_offer
          discount_percent
          show_discount_timer
          main_price
        }
        details {
          count
          limit_min
          limit_max
          limit_max_reached
        }
        seo {
          url
          full_url
        }
        has_variant
        variants {
          labels {
            id
            key
            title
            value
          }
          variant {
            id
            name
            type
            key
          }
        }
        mix_variant {
          keys
          custom_fields
          labels_obj
          bundle_label
          details {
            count
            limit_min
            limit_max
            limit_max_reached
          }
          price {
            offer_expireAt
            offer_startAt
            show_discount_timer
            price
            offer_price
            has_offer
            discount_percent
            main_price
          }
          media_gallery ${media_with_details}
        }
        media ${media_with_details}
        media_gallery ${media_with_details}
        category {
          id
          title
          seo {
            url
          }
        }
}`;

export const product_page = `{
  id
  title
  title_en
  summary
  description
  main_features
  has_rating
  has_comment
  has_question_box
  is_special
  user_rate
  rate_counts
  average_rate
  is_favorite
  is_notify
  strengths
  weaknesses
  comments_count(type:$type) 
  attribute_groups ${attribute_groups}
  variants ${variants}
  mix_variant ${mix_variants}
  media_gallery {
    alt
    url
  }
  category ${product_category}
  brand ${product_brand}
  seo {
    url
  }
}`;

export const torob_product_mockup = `
  {
    id
    seo {
      full_url
    }
    mix_variant {
      details {
        count
        product_code
      }
      price {
        price
        main_price
      }
    }
  }
`;

export const zoomit_product_mockup = `
  {
    id
    title
    title_en
    summary
    seo {
      full_url
    }
    mix_variant {
      title
      labels {
        title
        variant {
          type
          name
        }
      }
      details {
        count
        product_code
      }
      price {
        price
        main_price
      }
    }
  }
`;

export const zarehbin_product_mockup = `
  {
    id
    title
    title_en
    summary
    seo {
      full_url
    }
    category {
      title
      parents {
        title
      }
    }
    media {
      url
      full_url
    }
    media_gallery {
      url
      full_url
      main
    }
    attribute_groups {
      attributes {
        attribute {
          key
          title
        }
        attribute_value {
          value
          unit
        }
      }
    }
    mix_variant {
      title
      is_main_price
      keys
      labels {
        title
        variant {
          key
          type
          name
        }
      }
      details {
        count
        product_code
      }
      price {
        price
        main_price
      }
      media {
        url
        full_url
      }
      media_gallery {
        url
        full_url
        main
      }
    }
  }
`;

export const product_card = `{
  id
  title
  seo {
      url
      full_url
  }
  media_gallery {
      url
  }
  category {
      title
  }
  price {
      price
      offer_price
      discount_percent
      show_discount_timer
      main_price
  }
  details {
      count
  }
  
}`;
export const gift_product_card = `{
  id
  title
  seo {
      url
      full_url
  }
  category {
      title
  }
  mix_variant {
  keys
   price {
      price
      offer_price
      discount_percent
      show_discount_timer
      main_price
    }
    details {
        count
    }
    media_gallery {
      url
    }
  }
 
  
}`;
export const product_card_search = `{
  id
  title
  seo {
      url
      full_url
  }
  media_gallery {
      url
  }
  category {
      title
  }
  price {
      price
      offer_price
      discount_percent
      show_discount_timer
  }
  details {
      count
  }
  mix_variant {
    title
    keys
  }
}`;

export const related_products = `{
  related_products { 
        id
        title
        seo {
            url
            full_url
        }
        media_gallery {
            url
        }
        category {
            title
        }
        price {
            price
            offer_price
            discount_percent
            show_discount_timer
        }
        details {
            count
        }
    }
}`;

export const product_page_with_related_products = `{
  id
  title
  title_en
  price_contact_number
  summary
  description
  main_features
  has_rating
  has_comment
  has_question_box
  is_special
  user_rate
  rate_counts
  average_rate
  is_favorite
  is_notify
  strengths
  weaknesses
  comments_count(type:1) 
  forums_count: comments_count(type:2) 
  attribute_groups ${attribute_groups}
  variants ${variants}
  mix_variant ${mix_variants}
  media_gallery {
    alt
    url
  }
  category ${product_category}
  brand ${product_brand}
  seo {
    url
  }
   related_products ${widget_product}
   suggestion_products ${widget_product}
   custom_fields
}`;

export const favorite_products = `
{
  id
  product_id
  title
  seo {
    url
    full_url
  }
  
  mix_variant {
    is_favorite
    title
    keys
    details {
      count
      limit_min
      limit_max
    }
    price {
      price
      offer_price
      has_offer
    }
    media {
      alt
      url
    }
  }
  media {
    alt
    url
  }
}
`;

export const product_tutorials = `{
  title
  seo {
    full_url
  }
  tutorial_video {
    url
    alt
  }
  tutorial_video_poster {
    url
    alt
  }
}`;

export const emalls_product_mockup = `
  {
    id
    title
    category {
      title
    }
    seo {
      full_url
    }
    mix_variant {
      title
      labels {
        title
        variant {
          type
          name
        }
      }
      details {
        count
        product_code
      }
      price {
        price
        main_price
      }
    }
  }
`;
